export default "__VITE_ASSET__f2eab5b6__"